import { getRequest } from "../apiRequest";
import { apiRoutes } from "../Constants/ApiRoutes";

export const getArticles = async (id, pathParams) => {
  if (!id) {
    return;
  }
  const url = `${apiRoutes.categories}/${id}/${apiRoutes.getArticlesInCategory}`;
  const response = await getRequest(url, null, pathParams);
  return response.data.data.articles;
};

export const getParticularArticle = async (articleSlug, pathParams) => {
  if (!articleSlug) {
    return;
  }
  const url = `${apiRoutes.getParticularArticle}/${articleSlug}`;
  const response = await getRequest(url, null, pathParams);
  return response.data.data;
};

export const articleSearch = (searchTerm, pathParams, signal) => {
  if (!searchTerm) {
    return;
  }
  const url = `${apiRoutes.getParticularArticle}/${apiRoutes.articleSearch}`;
  return getRequest(url, null, pathParams, undefined, undefined, signal ).then( response => {
    // handling signal abort here as Bifrost interface does not expose signal param.
    if( signal.aborted )throw new Error("signal aborted");
    else return response;
  });
};
